import React from "react";
import { StyleSheet, View, ScrollView } from "react-native";

import { getStateData } from "../../../helpers/utils";

import Header from "../common/header";

import SearchFiltersSets from "../common/search-bar/SearchFiltersSets";
import BottomButton from "../common/BottomButton";
import ManaTextInput from "../common/ManaTextInput";
import appStyles from "../../appStyles";
import ImageComponent from "../common/ImageComponent";
import ManaEmojiPicker from "../common/emoji-picker/ManaEmojiPicker";
import EditTagFabButton from "./EditTagFabButton";

export default class EditTagPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      isLoading: true,
      tag: {},
      activity: {},
      selectedSets: [],
      openEmojiDialog: false,
    };
  }

  componentDidMount = async () => {
    if (this.controller.hasNavigation()) {
      this.focusListenerUnsub = this.props.navigation.addListener(
        "focus",
        () => {
          this.refreshPage();
        },
      );
    } else {
      this.refreshPage();
    }
  };

  componentWillUnmount = async () => {
    if (this.focusListenerUnsub) this.focusListenerUnsub();
  };

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params?.args;
    } else {
      return this.controller.state.screenArgs?.args?.args;
    }
  }

  refreshPage = async () => {
    const { tag, activity } = this.getArgs() || {};

    if (!tag) {
      this.controller.changePage("feed", {
        selectedPage: "rn:activities",
        args: {},
      });
      return;
    }

    const sets = getStateData(this.controller.state, "sets", tag.sets, "name");
    const selectedSets = sets.filter((s) => s.isSelected).map((s) => s.id);

    this.setState((state) => ({
      ...state,
      isLoading: false,
      tag,
      activity,
      sets,
      selectedSets,
      isEditMode: !!tag.edit_id,
    }));
  };

  preselectCurrentSets = (tagSets = [], allSets = []) => {
    if (tagSets.length == 0) return allSets;

    return allSets.map((s) => {
      return {
        ...s,
        isSelected: tagSets.includes(s.id),
      };
    });
  };

  updateTagName = (name) => {
    this.setState(
      (state) => ({
        ...state,
        tag: {
          ...this.state.tag,
          edit_name: name,
        },
      }),
      () => this.saveTag(),
    );
  };

  updateSelectedSets = ({ sets }) => {
    this.setState(
      (state) => ({
        ...state,
        selectedSets: sets,
      }),
      () => this.saveTag(),
    );
  };

  updateEmoji = (emoji) => {
    this.setState(
      (state) => ({
        ...state,
        tag: {
          ...this.state.tag,
          edit_icon: emoji.unified || emoji.id,
        },
      }),
      () => this.saveTag(),
    );
  };

  saveTag = (userTriggered = false) => {
    const { activity, tag, selectedSets, isEditMode } = this.state;

    // On create page save is triggered by the user
    if (!userTriggered && !isEditMode) return;

    this.setState((state) => ({ ...state, isLoading: true }));

    this.controller.tracking.track("Edit Tag");
    console.log("Edit Tag");
    this.controller.cardActionWithCallback(
      {
        action: "save",
        target: "tag",
        edit_id: tag.edit_id,
        edit_icon: tag.edit_icon,
        edit_name: tag.edit_name,
        source_id_activity: tag.source_id_activity,
        sets: selectedSets,
        edit_is_active: "checked",
      },
      (action, data) => {
        this.setState((state) => ({ ...state, isLoading: false }));

        // On edit mode remain on page
        if (isEditMode) return;

        if (this.controller.hasNavigation() && this.controller.navigation) {
          this.controller.goBack();
          return;
        }

        const returnUrl = this.controller.getReturnUrl();

        if (returnUrl === "edit_activity") {
          this.controller.changePage("feed", {
            selectedPage: returnUrl,
            args: {
              new_tag: {
                ...tag,
                id: data.id,
                name: tag.edit_name,
              },
              activity: {
                ...activity,
                tags: [data.id, ...activity.tags],
              },
            },
          });
        }

        if (returnUrl) this.controller.changePage(returnUrl);
      },
    );
  };

  // ------------------------------------- EMOJI -------------------------------------
  toggleEmojiDialog = (isOpen = true) => {
    this.setState((state) => ({ ...state, openEmojiDialog: isOpen }));
  };

  updateEmoji = (emoji) => {
    this.setState(
      (state) => ({
        ...state,
        tag: {
          ...this.state.tag,
          edit_icon: emoji.unified || emoji.id,
        },
      }),
      () => this.saveTag(),
    );
  };

  render() {
    const {
      tag,
      activity,
      sets,
      isEditMode,
      isLoading,
      openEmojiDialog,
    } = this.state;

    const buttonText =
      activity && activity.edit_name
        ? `Create and add to ${activity.edit_name}`
        : isEditMode
        ? "Update tag"
        : "Create tag";

    return (
      <View style={appStyles.container}>
        <ManaEmojiPicker
          isOpen={openEmojiDialog}
          onConfirm={this.updateEmoji}
          onClose={() => this.toggleEmojiDialog(false)}
        />

        <Header
          controller={this.controller}
          title={tag.edit_id ? "Edit Tag" : "New Tag"}
          hideAvatar
          returnPage={activity ? "rn:edit_activity" : "rn:activities"}
          returnArgs={activity ? { activity } : {}}
          isLoading={isLoading}
        />

        <ScrollView style={appStyles.scrollView}>
          <View>
            <View style={[styles.imageContainer]}>
              <ImageComponent
                styles={styles.icon}
                icon={tag && tag.edit_icon}
                onPress={() => this.toggleEmojiDialog(true)}
              />
            </View>

            <ManaTextInput
              style={{ paddingLeft: 50 }}
              name={"tagName"}
              placeholderTextColor="#9C9EB9"
              placeholder="Tag name"
              onTextChanged={(text) => this.updateTagName(text)}
              value={tag.edit_name || ""}
            />
          </View>
          {sets ? (
            <SearchFiltersSets
              sets={sets}
              title="Core Elements"
              hideCollapse
              initialNumToRender={4}
              callback={this.updateSelectedSets}
            />
          ) : null}
        </ScrollView>

        <EditTagFabButton mariOptions={{ mariMessage: this.state.message }} />

        {!isEditMode ? (
          <View style={appStyles.footerOptions}>
            <BottomButton
              styles={styles}
              disabled={!tag.edit_name}
              buttonText={buttonText}
              onPress={() => this.saveTag(true)}
            />
          </View>
        ) : null}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    maxWidth: "100%",
    marginTop: 20,
    marginHorizontal: 10,
  },
  imageContainer: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: "#FFF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  icon: {
    width: 30,
    height: 30,
  },
});
